<template>
  <vs-popup
    class="popup"
    button-close-hidden
    v-bind="$attrs"
    v-on="$listeners"
  >
    <h3 class="vs-popup--title-on-top">
      View Plan
    </h3>
    <img
      class="vs-popup--close-button"
      :src="require('@/assets/shipo-popup-icon-close.svg')"
      @click="$emit('close')"
    >
    <div
      id="detailContainer"
      class="w-full mt-12 vs-con-loading__container"
    >
      <vs-row
        class="grid grid-cols-2 gap-4"
        vs-w="12"
      >
        <vs-col
          class="font-semibold"
          v-for="tab in tabs"
          :key="tab.value"
        >
          <button
            @click="activeTab = tab.value"
            :class="[
              'w-full px-5 py-3 text-lg font-semibold text-white border-0 rounded-t-lg block',
              activeTab === tab.value ? 'bg-primary-accent border-0 opacity-90' : 'text-gray-500 bg-grey-002'
            ]"
          >
            {{ tab.label }}
          </button>
        </vs-col>
      </vs-row>
      <div class="w-full border border-grey-002 rounded-b-lg">
        <div
          v-if="activeTab === 1"
          class="p-4 space-y-6"
        >
          <!-- Trip Detail -->
          <div class="grid grid-cols-2 gap-6">
            <!-- Left Column -->
            <div class="border rounded-lg p-4 space-y-2">
              <div
                v-for="(item, i) in leftDetails"
                :key="i"
                class="flex justify-between"
              >
                <span class="font-medium">{{ item.label }}</span>
                <span class="text-purple-700">{{ item.value }}</span>
              </div>
            </div>

            <!-- Right Column -->
            <div class="border rounded-lg p-4 space-y-2">
              <div
                v-for="(item, i) in rightDetails"
                :key="i"
                class="flex justify-between"
              >
                <span class="font-medium">{{ item.label }}</span>
                <span class="text-purple-700">{{ item.value }}</span>
              </div>
            </div>
          </div>

          <!-- Product Detail -->
          <div class="border rounded-lg">
            <div class="p-4 font-semibold text-purple-700">
              Product Detail
            </div>
            <table class="w-full border-t">
              <thead class="bg-gray-50">
                <tr>
                  <th class="text-left px-4 py-2 w-12">
                    No
                  </th>
                  <th class="text-left px-4 py-2">
                    Product Name
                  </th>
                  <th class="text-right px-4 py-2">
                    Tonnage
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(p, i) in productData"
                  :key="i"
                  class="border-t"
                >
                  <td class="px-4 py-2">
                    {{ i + 1 }}
                  </td>
                  <td class="px-4 py-2">
                    {{ p.product_id }}
                  </td>
                  <td class="px-4 py-2 text-right">
                    {{ p.tonnage.toLocaleString() }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          v-if="activeTab === 2"
          class="p-4 space-y-6"
        >
          <!-- Trip Info -->
          <div class="border rounded-xl p-4 space-y-2">
            <div
              v-for="(item, i) in tripInfo"
              :key="i"
              class="flex justify-between"
            >
              <span class="font-medium">{{ item.label }}</span>
              <span class="text-purple-700">{{ item.value }}</span>
            </div>
          </div>

          <!-- Timeline -->
          <div class="grid grid-cols-2 gap-6">
            <!-- Left Column -->
            <div class="border rounded-xl p-4 space-y-2">
              <div
                v-for="(item, i) in timelineLeft"
                :key="i"
                class="flex justify-between"
              >
                <span class="font-medium">{{ item.label }}</span>
                <span class="text-purple-700">{{ item.value }}</span>
              </div>
            </div>

            <!-- Right Column -->
            <div class="border rounded-xl p-4 space-y-2">
              <div
                v-for="(item, i) in timelineRight"
                :key="i"
                class="flex justify-between"
              >
                <span class="font-medium">{{ item.label }}</span>
                <span class="text-purple-700">{{ item.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalDetailBLU',
  props: {
    bluPlanId: {
      type: Number,
      default: () => null
    }
  },
  computed: {
    ...mapGetters({
      detailPlan: 'BargeLineUp/detailPlan'
    })
  },
  watch: {
    bluPlanId: {
      deep: true,
      handler(val) {
        if (val) {
          this.fetchDetailBluPlan(val)
        }
      }
    },
    detailPlan: {
      deep: true,
      handler(val) {
        if (val) {
          this.mapDetailToValues(val)
        }
        this.isLoading = false
      }
    },
    isLoading: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.$vs.loading({
            type: 'radius',
            color: 'primary',
            container: '#detailContainer',
            scale: 0.5
          })

          return
        }

        this.$vs.loading.close('#detailContainer > .con-vs-loading')
      }
    }
  },
  data() {
    return {
      activeTab: 1,
      tabs: [
        { label: 'General Information', value: 1 },
        { label: 'Checkpoints', value: 2 }
      ],
      leftDetails: [
        { key: 'trip_number', label: "Trip No.", value: "" },
        { key: 'name_of_vessel', label: "Vessel Name", value: "" },
        { key: 'end_user', label: "End User", value: "" },
        { key: 'tug', label: "Tug Name", value: "" },
        { key: 'barge', label: "Barge Name", value: "" },
        { key: 'fleet_id', label: "Fleet ID", value: "" },
        { key: 'shipper', label: "Shipper", value: "" }
      ],
      rightDetails: [
        { key: 'loading_date', label: "Loading Date", value: "" },
        { key: 'pol', label: "POL", value: "" },
        { key: 'pod', label: "POD", value: "" },
        { key: 'route', label: "Route", value: "" },
        { key: 'term', label: "Term", value: "" },
        { key: 'product_id', label: "Product ID", value: "" },
        { key: 'cargo_demand', label: "Cargo Demand", value: "" }
      ],
      productData: [],
      tripInfo: [
        { key: 'trip_start', label: "Trip Start", value: "" },
        { key: 'trip_end', label: "Trip End", value: "" },
        { key: 'barge_cycle', label: "Barge Cycle Days", value: "" }
      ],
      timelineLeft: [
        { key: 'arrive_smds', label: "Arrive SMDS", value: "" },
        { key: 'depart_smds', label: "Depart SMDS", value: "" },
        { key: 'arrive_pol', label: "Arrive POL", value: "" },
        { key: 'loading_start', label: "Loading Start", value: "" },
        { key: 'loading_end', label: "Loading End", value: "" },
        { key: 'cast_off', label: "Cast Off", value: "" },
        { key: 'departure', label: "Departure", value: "" },
        { key: 'smd_for_bridge', label: "SMD for Bridge", value: "" }
      ],
      timelineRight: [
        { key: 'open_bridge', label: "Open Bridge", value: "" },
        { key: 'close_bridge', label: "Close Bridge", value: "" },
        { key: 'actual_passing_bridge', label: "Passing Bridge", value: "" },
        { key: 'arrive_pod', label: "Arrive POD", value: "" },
        { key: 'unloading_start', label: "Unloading Start", value: "" },
        { key: 'unloading_end', label: "Unloading End", value: "" },
        { key: 'cast_off_2', label: "Cast Off", value: "" },
        { key: 'departure_2', label: "Departure", value: "" },
        { key: 'arrive_smdr', label: "Arrive SMDR", value: "" }
      ],
      isLoading: false
    }
  },
  methods: {
    async fetchDetailBluPlan(id) {
      this.isLoading = true
      try {
        await this.$store.dispatch('BargeLineUp/getBargeDetailPlan', id)
      } catch (err) {
        this.isLoading = false
        this.showFailedNotification(this, 'Failed to fetch BLU detail plan data')
      }
    },
    mapDetailToValues(detail) {
      const src = detail || {}

      // left / right
      this.leftDetails.forEach(it => {
        const v = src[it.key]
        it.value = (v === null || typeof v === "undefined") ? "-" : v
      })

      this.rightDetails.forEach(it => {
        let v = src[it.key]
        if (it.key === "loading_date" && v) v = this.formatIsoDate(v, true)
        if (it.key === "cargo_demand" && typeof v === "number") v = v.toLocaleString()
        it.value = (v === null || typeof v === "undefined") ? "-" : v
      })

      // plan-based timelines & trip info
      const plan = src.checkpoint_plan || {}
      this.tripInfo.forEach(it => {
        const v = plan[it.key]
        if (it.key === 'barge_cycle') {
          it.value = v ? v : "-"
        } else {
          it.value = v ? this.formatIsoDate(v, false) : "-"
        }
      });

      this.timelineLeft.forEach(it => {
        const v = plan[it.key];
        it.value = v ? this.formatIsoDate(v, false) : "-"
      });

      this.timelineRight.forEach(it => {
        const v = plan[it.key];
        it.value = v ? this.formatIsoDate(v, false) : "-"
      });

      // product data mapping
      const prodArr = Array.isArray(src.product_data)
        ? src.product_data
        : Array.isArray(src.blu_tonnage_per_products)
          ? src.blu_tonnage_per_products
          : []

      this.productData = prodArr.map(p => ({
        product_id: p.product_id || p.productId || "",
        tonnage: Number(p.tonnage ?? p.value ?? 0)
      }));
    },
    formatIsoDate(iso, dateOnly = false) {
      if (!iso) return "-"
      const m = this.moment(iso)
      if (!m.isValid()) return "-"
      return dateOnly
        ? m.format("DD-MMM-YYYY")
        : m.format("DD-MMM-YYYY HH:mm")
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  /deep/.vs-popup {
    @apply w-auto;
    @apply rounded-2xl;
    min-width: 50rem;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply relative;
      @apply p-4;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply h-full;
      @apply w-full;
      @apply items-center;

      &-title {
        @apply text-2xl;
        @apply font-semibold;
        @apply text-grey;
        @apply mt-8;
      }
    }

    &--img {
      width: 152px;
    }

    &--close-button {
      @apply cursor-pointer;
      @apply absolute;
      width: 35px;
      top: 1rem;
      right: 1rem;
    }

    &--title-on-top {
      @apply absolute;
      width: 90%;
      top: 1.5rem;
      left: 1rem;
      font-weight: 600;
      font-size: 1.5rem;
    }

    &--ok {
      @apply rounded-xl;
      @apply border-2;
      @apply mt-20;
      @apply py-4;
      @apply min-w-button;
      @apply font-semibold;
      height: calc( 1rem * 10 / 3 );

      &.shadow-secondary {
        -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
        box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
      }

      &:focus {
        @apply outline-none;
        @apply border-none;
      }
    }

    p {
      @apply text-base;
      @apply text-grey-001;
    }
  }
}
</style>
